import React from 'react';

import { ArrowRightIcon } from '@change/ds-icons';

import { Text } from '@change/ds-core-ui/next';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { PromptInput, PromptInputActions, PromptInputTextarea } from '../PromptInput';

import { useSapIssueForm } from './hooks/useSapIssueForm';

export const SapIssueForm: React.FC = () => {
	const { translate } = useI18n();
	const {
		data: { isSubmitting },
		actions: { onSubmit },
	} = useSapIssueForm();

	return (
		<div className="flex w-full flex-col items-center justify-center py-8">
			<div className="flex w-full max-w-[600px] flex-col gap-4">
				<div>
					<Text className="text-center" variant="heading" size="small" as="h1" id="sap-input-heading">
						<Translate value="corgi.homepage.hero_section.input_prompt_label" />
					</Text>
				</div>
				<form onSubmit={onSubmit} data-qa="sap-input-prompt-form">
					<PromptInput data-qa="sap-prompt">
						<PromptInputTextarea
							maxLength={500}
							name="issue"
							placeholder={translate('corgi.homepage.hero_section.input_prompt_placeholder')}
							aria-labelledby="sap-input-heading"
						/>

						<PromptInputActions data-qa="prompt-input-actions">
							<button
								type="submit"
								data-qa="prompt-input-actions-button"
								className="bg-fill-interactive ml-auto inline-flex h-11 w-11 items-center justify-center rounded-[64px] p-1"
							>
								<div aria-live="polite">
									{isSubmitting ? (
										<Loader
											size={24}
											aria-label={translate('corgi.homepage.hero_section.input_prompt_submit_button_loading')}
										/>
									) : (
										<ArrowRightIcon
											aria-label={translate('corgi.homepage.hero_section.input_prompt_submit_button')}
											className="text-icon-strong"
										/>
									)}
								</div>
							</button>
						</PromptInputActions>
					</PromptInput>
				</form>
			</div>
		</div>
	);
};
